import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import init from "./modules/init";
import branches from "./modules/branches";
import temporaryData from "./modules/temporaryData";
import duplicateCustomerTemporary from "./modules/duplicateCustomerTemporary";
import settings from "./modules/settings";
import loginUserInfo from "./modules/loginUserInfo";
import paymentMethods from "./modules/paymentMethod";
import eStorePaymentMethods from "./modules/eStorePaymentMethods";
import services from "./modules/services";
import bookingList from "./modules/bookingList";
import appointmentHistory from "./modules/appointmentHistory";
import purchaseHistory from "./modules/purchaseHistory";
import customerSavedCard from "./modules/customerSavedCard";
import redemptionList from "./modules/redemptionList";
import mySalon from "./modules/mySalon";
import eStore from "./modules/eStore";
import cart from "./modules/cart";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    init,
    branches,
    temporaryData,
    duplicateCustomerTemporary,
    settings,
    loginUserInfo,
    paymentMethods,
    eStorePaymentMethods,
    services,
    bookingList,
    appointmentHistory,
    purchaseHistory,
    customerSavedCard,
    redemptionList,
    mySalon,
    eStore,
    cart,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer: (state) => ({
        temporaryData: state.temporaryData,
        duplicateCustomerTemporary: state.duplicateCustomerTemporary,
        branches: state.branches,
        loginUserInfo: state.loginUserInfo,
        paymentMethods: state.paymentMethods,
        eStorePaymentMethods: state.eStorePaymentMethods,
        services: state.services,
      }),
    }),
  ],
});
